const conf = {
  "enemy": [
    "Terminid",
    "Automaton",
    "Illuminate"
  ],
  "difficulty": [
    "1 - Trivial or greater",
    "2 - Easy or greater",
    "3 - Medium or greater",
    "4 - Challenging or greater",
    "5 - Hard or greater",
    "6 - Extreme or greater",
    "7 - Suicide Mission or greater",
    "8 - Impossible or greater",
    "9 - Helldive or greater",
    "10 - Super Helldive"
  ],
  "difficultyWeights": [
    0.0200000000, // "1 - Trivial or greater"
    0.0700000000, // "2 - Easy or greater"
    0.0700000000, // "3 - Medium or greater"
    0.1200000000, // "4 - Challenging or greater"
    0.1200000000, // "5 - Hard or greater"
    0.1200000000, // "6 - Extreme or greater"
    0.1200000000, // "7 - Suicide Mission or greater"
    0.1200000000, // "8 - Impossible or greater"
    0.1200000000, // "9 - Helldive or greater"
    0.1200000000, // "10 - Super Helldive"
  ],
  "duration": [
    "10 minute or more",
    "12 minute or more",
    "15 minute or more",
    "20 minute or more",
    "40 minute"
  ],
  "durationWeights": [
    0.0500000000, // "10 minute or more"
    0.0500000000, // "12 minute or more"
    0.0500000000, // "15 minute or more"
    0.0500000000, // "20 minute or more"
    0.8000000000, // "40 minute"
  ],
  "teamplay": [
    "Solo",
    "Squad"
  ],
  "teamplayWeights": [
    0.2000000000, // "Solo"
    0.8000000000, // "Squad"
  ],
  "stars": [
    "0 stars or more",
    "1 stars or more",
    "2 stars or more",
    "3 stars or more",
    "4 stars or more",
    "5 stars"
  ],
  "primary": [
    "AR-23 Liberator",
    "AR-23A Liberator Carbine",
    "AR-23C Liberator Concussive",
    "AR-23P Liberator Penetrator",
    "AR-61 Tenderizer",
    "ARC-12 Blitzer",
    "BR-14 Adjudicator",
    "CB-9 Exploding Crossbow",
    "FLAM-66 Torcher",
    "JAR-5 Dominator",
    "LAS-16 Sickle",
    "LAS-5 Scythe",
    "MP-98 Knight",
    "Plas-1 Scorcher",
    "Plas-101 Purifier",
    "R-2124 Constitution",
    "R-36 Eruptor",
    "R-63 Diligence",
    "R-63CS Diligence Counter Sniper",
    "SG-20 Halt",
    "SG-225 Breaker",
    "SG-225IE Breaker Incendiary",
    "SG-225SP Breaker SPRAY&PRAY",
    "SG-451 Cookout",
    "SG-8 Punisher",
    "SG-8P Punisher Plasma",
    "SG-8S Slugger",
    "SMG-32 Reprimand",
    "SMG-37 Defender",
    "SMG-72 Pummeler",
    "StA-52 Assault Rifle",
    "StA-11 SMG",
    "PLAS-39 Accelerator Rifle",
    "LAS-17 Double-Edge Sickle",
    "R-6 Deadeye",
    "R-2 Amendment",
    "AR-32 Pacifier",
    "VG-70 Variable",
    "MA5C Assault Rifle",
    "M7S SMG",
    "M90A Shotgun",
    "AR-2 Coyote",
    "AR/GL-21 One-Two",
    "DBS-2 Double Freedom",
    "R-72 Censor",
    "AR-59 Suppressor",
    "LAS-16 Trident",
    "SMG/FLAM-34 Stoker",
    "SG-225SP Sweeper",
  ],
  "primaryWeights": [
    0.0210328236, // "AR-23 Liberator"
    0.0210989214, // "AR-23A Liberator Carbine"
    0.0209968965, // "AR-23C Liberator Concussive"
    0.0208612272, // "AR-23P Liberator Penetrator"
    0.0217956307, // "AR-61 Tenderizer"
    0.0193744544, // "ARC-12 Blitzer"
    0.0200889030, // "BR-14 Adjudicator"
    0.0131885020, // "CB-9 Exploding Crossbow"
    0.0202234520, // "FLAM-66 Torcher"
    0.0215689082, // "JAR-5 Dominator"
    0.0202594746, // "LAS-16 Sickle"
    0.0207898393, // "LAS-5 Scythe"
    0.0207814256, // "MP-98 Knight"
    0.0218976779, // "Plas-1 Scorcher"
    0.0215830642, // "Plas-101 Purifier"
    0.0186629517, // "R-2124 Constitution"
    0.0151494322, // "R-36 Eruptor"
    0.0205326015, // "R-63 Diligence"
    0.0208630652, // "R-63CS Diligence Counter Sniper"
    0.0212285075, // "SG-20 Halt"
    0.0195080923, // "SG-225 Breaker"
    0.0225573590, // "SG-225IE Breaker Incendiary"
    0.0226851505, // "SG-225SP Breaker SPRAY&PRAY"
    0.0212447743, // "SG-451 Cookout"
    0.0203484122, // "SG-8 Punisher"
    0.0213961942, // "SG-8P Punisher Plasma"
    0.0209451869, // "SG-8S Slugger"
    0.0202400290, // "SMG-32 Reprimand"
    0.0206490684, // "SMG-37 Defender"
    0.0210230119, // "SMG-72 Pummeler"
    0.0206811000, // "StA-52 Assault Rifle"
    0.0213240482, // "StA-11 SMG"
    0.0203036956, // "PLAS-39 Accelerator Rifle"
    0.0204126219, // "LAS-17 Double-Edge Sickle"
    0.0209695674, // "R-6 Deadeye"
    0.0213616925, // "R-2 Amendment"
    0.0191473453, // "AR-32 Pacifier"
    0.0205175581, // "VG-70 Variable"
    0.0197273344, // "MA5C Assault Rifle"
    0.0190694094, // "M7S SMG"
    0.0228466479, // "M90A Shotgun"
    0.0213749076, // "AR-2 Coyote"
    0.0201177513, // "AR/GL-21 One-Two"
    0.0176823239, // "DBS-2 Double Freedom"
    0.0207299948, // "R-72 Censor"
    0.0197357449, // "AR-59 Suppressor"
    0.0192869376, // "LAS-16 Trident"
    0.0211842682, // "SMG/FLAM-34 Stoker"
    0.0209520137, // "SG-225SP Sweeper"
  ],
  "secondary": [
    "GP-31 Grenade Pistol",
    "LAS-7 Dagger",
    "P-2 Peacemaker",
    "P-4 Senator",
    "P-11 Stim Pistol",
    "P-19 Redeemer",
    "P-72 Crisper",
    "P-113 Verdict",
    "PLAS-15 Loyalist",
    "SG-22 Bushwhacker",
    "CQC-19 Stun Lance",
    "CQC-30 Stun Baton",
    "CQC-5 Combat Hatchet",
    "GP-31 Ultimatum",
    "LAS-58 Talon",
    "CQC-2 Saber",
    "P-92 Warrant",
    "M6C/SOCOM Pistol",
    "CQC-42 Machete",
    "P-35 Re-Educator",
    "CQC-73 Entrenchment Tool",
    "P-69 Veto",
  ],
  "secondaryWeights": [
    0.0300263382, // "GP-31 Grenade Pistol"
    0.0461449851, // "LAS-7 Dagger"
    0.0461476140, // "P-2 Peacemaker"
    0.0444054093, // "P-4 Senator"
    0.0582347964, // "P-11 Stim Pistol"
    0.0457245508, // "P-19 Redeemer"
    0.0442862923, // "P-72 Crisper"
    0.0486591685, // "P-113 Verdict"
    0.0457489189, // "PLAS-15 Loyalist"
    0.0458796731, // "SG-22 Bushwhacker"
    0.0481763288, // "CQC-19 Stun Lance"
    0.0450966039, // "CQC-30 Stun Baton"
    0.0451868680, // "CQC-5 Combat Hatchet"
    0.0429216891, // "GP-31 Ultimatum"
    0.0437229840, // "LAS-58 Talon"
    0.0453841744, // "CQC-2 Saber"
    0.0453937476, // "P-92 Warrant"
    0.0436479070, // "M6C/SOCOM Pistol"
    0.0461706213, // "CQC-42 Machete"
    0.0449807641, // "P-35 Re-Educator"
    0.0456465411, // "CQC-73 Entrenchment Tool"
    0.0484140241, // "P-69 Veto"
  ],
  "grenade": [
    "G-3 Smoke",
    "G-4 Gas Grenade",
    "G-6 Frag",
    "G-10 Incendiary",
    "G-12 High Explosive",
    "G-13 Incendiary Impact",
    "G-16 Impact",
    "G-23 Stun",
    "G-123 Thermite",
    "K-2 Throwing Knife",
    "G-50 Seeker",
    "TED-63 Dynamite",
    "G-142 Pyrotech",
    "G-109 Urchin",
    "G-31 Arc",
    "G-7 Pineapple",
    "TM-1 Lure Mine",
    "G/SH-39 Shield",
    "G-89 Smokescreen",
    "G-48 Giga Grenade",
  ],
  "grenadeWeights": [
    0.0632452479, // "G-3 Smoke"
    0.0674335517, // "G-4 Gas Grenade"
    0.0337398581, // "G-6 Frag"
    0.0320030566, // "G-10 Incendiary"
    0.0294200220, // "G-12 High Explosive"
    0.0308374887, // "G-13 Incendiary Impact"
    0.0314045619, // "G-16 Impact"
    0.0656047329, // "G-23 Stun"
    0.0316873380, // "G-123 Thermite"
    0.0999593238, // "K-2 Throwing Knife"
    0.0637601575, // "G-50 Seeker"
    0.0324403233, // "TED-63 Dynamite"
    0.0327174031, // "G-142 Pyrotech"
    0.0647734354, // "G-109 Urchin"
    0.0635574423, // "G-31 Arc"
    0.0327974086, // "G-7 Pineapple"
    0.0631910536, // "TM-1 Lure Mine"
    0.0660148265, // "G/SH-39 Shield"
    0.0628017169, // "G-89 Smokescreen"
    0.0326110514, // "G-48 Giga Grenade"
  ],
  "stratagem": [
    "A/AC-8 Autocannon Sentry",
    "A/ARC-3 Tesla Tower",
    "A/G-16 Gatling Sentry",
    "A/M-12 Mortar Sentry",
    "A/M-23 EMS Mortar Sentry",
    "A/MG-43 Machine Gun Sentry",
    "A/MLS-4X Rocket Sentry",
    "AC-8 Autocannon",
    "APW-1 Anti-Material Rifle",
    "ARC-3 Arc Thrower",
    "AX/AR-23 Guard Dog",
    "AX/TX-13 Guard Dog Dog Breath",
    "AX/LAS-5 Guard Dog Rover",
    "B-1 Supply Pack",
    "E/MG-101 HMG Emplacement",
    "Eagle 110m Rocket Pods",
    "Eagle 500kg Bomb",
    "Eagle Airstrike",
    "Eagle Cluster Bomb",
    "Eagle Napalm Airstrike",
    "Eagle Smoke Strike",
    "Eagle Strafing Run",
    "EAT-17 Expendable Anti-Tank",
    "EXO-45 Patriot Exosuit",
    "EXO-49 Emancipator Exosuit",
    "FAF-14 Spear",
    "FLAM-40 Flamethrower",
    "FX-12 Shield Generator Relay",
    "GL-21 Grenade Launcher",
    "GR-8 Recoilless Rifle",
    "LAS-98 Laser Cannon",
    "LAS-99 Quasar Cannon",
    "LIFT-850 Jump Pack",
    "M-105 Stalwart",
    "MD-6 Anti-Personnel Minefield",
    "MD-17 Anti-Tank Mines",
    "MD-I4 Incendiary Mines",
    "MG-206 Heavy Machine Gun",
    "MG-43 Machine Gun",
    "MLS-4X Commando",
    "Orbital 120MM HE Barrage",
    "Orbital 380MM HE Barrage",
    "Orbital Airburst Strike",
    "Orbital EMS Strike",
    "Orbital Gas Strike",
    "Orbital Gatling Barage",
    "Orbital Laser",
    "Orbital Napalm Barrage",
    "Orbital Precision Strike",
    "Orbital Railcannon Strike",
    "Orbital Smoke Strike",
    "Orbital Walking Barrage",
    "RL-77 Airburst Rocket Launcher",
    "RS-422 Railgun",
    "SH-20 Balistic Shield Backpack",
    "SH-32 Shield Generator Pack",
    "TX-41 Sterilizer",
    "SH-51 Directional Shield",
    "A/FLAM-40 Flame Sentry",
    "E/AT-12 Anti-Tank Emplacement",
    "M-102 Fast Recon Vehicle",
    "StA-X3 W.A.S.P. Launcher",
    "B-100 Portable Hellbomb",
    "MD-8 Gas Mines",
    "LIFT-860 Hover Pack",
    "E/GL-21 Grenadier Battlement",
    "CQC-1 One True Flag",
    "GL-52 De-Escalator",
    "AX/ARC-3 Guard Dog K-9",
    "Plas-45 Epoch",
    "A/LAS-98 Laser Sentry",
    "LIFT-182 Warp Pack",
    "MS-11 Solo Silo",
    "EAT-700 Expendable Napalm",
    "S-11 Speargun",
    "CQC-9 Defoliation Tool",
    "AZ/FLAM-75 Guard Dog Hot Dog",
    "M-1000 Maxigun",
    "B/MD C4 Pack",
    "GL-28 Belt-Fed Grenade Launcher",
    "EAT-411 Leveller",
    "CQC-20 Breaching Hammer",
    "TD-220 Bastion MK XVI",
    "A/GM-17 Gas Mortar Sentry",
    "B/FLAM-80 Cremator",
  ],
  "stratagemWeights": [
    0.0018740551, // "A/AC-8 Autocannon Sentry"
    0.0018284471, // "A/ARC-3 Tesla Tower"
    0.0018669060, // "A/G-16 Gatling Sentry"
    0.0018564290, // "A/M-12 Mortar Sentry"
    0.0018199949, // "A/M-23 EMS Mortar Sentry"
    0.0018601774, // "A/MG-43 Machine Gun Sentry"
    0.0018769108, // "A/MLS-4X Rocket Sentry"
    0.0000000001, // "AC-8 Autocannon"
    0.0000000001, // "APW-1 Anti-Material Rifle"
    0.0000000001, // "ARC-3 Arc Thrower"
    0.0137336253, // "AX/AR-23 Guard Dog"
    0.0136866070, // "AX/TX-13 Guard Dog Dog Breath"
    0.0133714607, // "AX/LAS-5 Guard Dog Rover"
    0.0128297004, // "B-1 Supply Pack"
    0.0018293281, // "E/MG-101 HMG Emplacement"
    0.0016125720, // "Eagle 110m Rocket Pods"
    0.0013967099, // "Eagle 500kg Bomb"
    0.0013879374, // "Eagle Airstrike"
    0.0018225022, // "Eagle Cluster Bomb"
    0.0016098765, // "Eagle Napalm Airstrike"
    0.0020810467, // "Eagle Smoke Strike"
    0.0014039049, // "Eagle Strafing Run"
    0.0000000001, // "EAT-17 Expendable Anti-Tank"
    0.0011634161, // "EXO-45 Patriot Exosuit"
    0.0011628218, // "EXO-49 Emancipator Exosuit"
    0.0000000001, // "FAF-14 Spear"
    0.0000000001, // "FLAM-40 Flamethrower"
    0.0212993668, // "FX-12 Shield Generator Relay"
    0.0000000001, // "GL-21 Grenade Launcher"
    0.0000000001, // "GR-8 Recoilless Rifle"
    0.0000000001, // "LAS-98 Laser Cannon"
    0.0000000001, // "LAS-99 Quasar Cannon"
    0.0138711371, // "LIFT-850 Jump Pack"
    0.0000000001, // "M-105 Stalwart"
    0.0018446454, // "MD-6 Anti-Personnel Minefield"
    0.0018082206, // "MD-17 Anti-Tank Mines"
    0.0018887622, // "MD-I4 Incendiary Mines"
    0.0000000001, // "MG-206 Heavy Machine Gun"
    0.0000000001, // "MG-43 Machine Gun"
    0.0000000001, // "MLS-4X Commando"
    0.0013639182, // "Orbital 120MM HE Barrage"
    0.0014111088, // "Orbital 380MM HE Barrage"
    0.0017996250, // "Orbital Airburst Strike"
    0.0018142720, // "Orbital EMS Strike"
    0.0018128533, // "Orbital Gas Strike"
    0.0018220550, // "Orbital Gatling Barage"
    0.0018052660, // "Orbital Laser"
    0.0016027683, // "Orbital Napalm Barrage"
    0.0018080768, // "Orbital Precision Strike"
    0.0018308032, // "Orbital Railcannon Strike"
    0.0020704504, // "Orbital Smoke Strike"
    0.0013822263, // "Orbital Walking Barrage"
    0.0000000001, // "RL-77 Airburst Rocket Launcher"
    0.0000000001, // "RS-422 Railgun"
    0.2360526967, // "SH-20 Balistic Shield Backpack"
    0.0136042651, // "SH-32 Shield Generator Pack"
    0.0000000001, // "TX-41 Sterilizer"
    0.5236189425, // "SH-51 Directional Shield"
    0.0018222088, // "A/FLAM-40 Flame Sentry"
    0.0018614083, // "E/AT-12 Anti-Tank Emplacement"
    0.0018464968, // "M-102 Fast Recon Vehicle"
    0.0000000001, // "StA-X3 W.A.S.P. Launcher"
    0.0137910059, // "B-100 Portable Hellbomb"
    0.0018109173, // "MD-8 Gas Mines"
    0.0136344581, // "LIFT-860 Hover Pack"
    0.0018235874, // "E/GL-21 Grenadier Battlement"
    0.0000000001, // "CQC-1 One True Flag"
    0.0000000001, // "GL-52 De-Escalator"
    0.0131095800, // "AX/ARC-3 Guard Dog K-9"
    0.0000000001, // "Plas-45 Epoch"
    0.0018674100, // "A/LAS-98 Laser Sentry"
    0.0142326915, // "LIFT-182 Warp Pack"
    0.0000000001, // "MS-11 Solo Silo"
    0.0000000001, // "EAT-700 Expendable Napalm"
    0.0000000001, // "S-11 Speargun"
    0.0000000001, // "CQC-9 Defoliation Tool"
    0.0142383668, // "AZ/FLAM-75 Guard Dog Hot Dog"
    0.0000000001, // "M-1000 Maxigun"
    0.0000000001, // "B/MD C4 Pack"
    0.0000000001, // "GL-28 Belt-Fed Grenade Launcher"
    0.0000000001, // "EAT-411 Leveller"
    0.0000000001, // "CQC-20 Breaching Hammer"
    0.0015613922, // "TD-220 Bastion MK XVI"
    0.0018145830, // "A/GM-17 Gas Mortar Sentry"
    0.0000000001, // "B/FLAM-80 Cremator"
  ],
  "supportStratagemWeights": [
    0.0189906937, // "AC-8 Autocannon"
    0.0362588769, // "APW-1 Anti-Material Rifle"
    0.0375837609, // "ARC-3 Arc Thrower"
    0.0257488943, // "EAT-17 Expendable Anti-Tank"
    0.0296204504, // "FAF-14 Spear"
    0.0359942573, // "FLAM-40 Flamethrower"
    0.0198727856, // "GL-21 Grenade Launcher"
    0.0202906416, // "GR-8 Recoilless Rifle"
    0.0361587415, // "LAS-98 Laser Cannon"
    0.0198671790, // "LAS-99 Quasar Cannon"
    0.0349296632, // "M-105 Stalwart"
    0.0378094045, // "MG-206 Heavy Machine Gun"
    0.0383795391, // "MG-43 Machine Gun"
    0.0206950102, // "MLS-4X Commando"
    0.0199429469, // "RL-77 Airburst Rocket Launcher"
    0.0357703528, // "RS-422 Railgun"
    0.0376492021, // "TX-41 Sterilizer"
    0.0241250857, // "StA-X3 W.A.S.P. Launcher"
    0.0564766210, // "CQC-1 One True Flag"
    0.0408792670, // "GL-52 De-Escalator"
    0.0372172758, // "Plas-45 Epoch"
    0.0386840300, // "MS-11 Solo Silo"
    0.0249077371, // "EAT-700 Expendable Napalm"
    0.0193493556, // "S-11 Speargun"
    0.0548243487, // "CQC-9 Defoliation Tool"
    0.0354685742, // "M-1000 Maxigun"
    0.0204939686, // "GL-28 Belt-Fed Grenade Launcher"
    0.0273103905, // "EAT-411 Leveller"
    0.0580228344, // "CQC-20 Breaching Hammer"
    0.0212491904, // "B/MD C4 Pack"
    0.0354289208, // "B/FLAM-80 Cremator"
  ],
  "BackpackStratagems": [
    "AC-8 Autocannon",
    "AX/AR-23 Guard Dog",
    "AX/TX-13 Guard Dog Dog Breath",
    "AX/LAS-5 Guard Dog Rover",
    "B-1 Supply Pack",
    "FAF-14 Spear",
    "FX-12 Shield Generator Relay",
    "GR-8 Recoilless Rifle",
    "LIFT-850 Jump Pack",
    "RL-77 Airburst Rocket Launcher",
    "SH-20 Balistic Shield Backpack",
    "SH-32 Shield Generator Pack",
    "SH-51 Directional Shield",
    "StA-X3 W.A.S.P. Launcher",
    "B-100 Portable Hellbomb",
    "LIFT-860 Hover Pack",
    "AX/ARC-3 Guard Dog K-9",
    "LIFT-182 Warp Pack",
    "M-1000 Maxigun",
    "AZ/FLAM-75 Guard Dog Hot Dog",
    "B/MD C4 Pack",
    "GL-28 Belt-Fed Grenade Launcher",
    "B/FLAM-80 Cremator",
  ],
  "SupportWeaponStratagems": [
    "AC-8 Autocannon",
    "APW-1 Anti-Material Rifle",
    "ARC-3 Arc Thrower",
    "EAT-17 Expendable Anti-Tank",
    "FAF-14 Spear",
    "FLAM-40 Flamethrower",
    "GL-21 Grenade Launcher",
    "GR-8 Recoilless Rifle",
    "LAS-98 Laser Cannon",
    "LAS-99 Quasar Cannon",
    "M-105 Stalwart",
    "MG-206 Heavy Machine Gun",
    "MG-43 Machine Gun",
    "MLS-4X Commando",
    "RL-77 Airburst Rocket Launcher",
    "RS-422 Railgun",
    "TX-41 Sterilizer",
    "StA-X3 W.A.S.P. Launcher",
    "CQC-1 One True Flag",
    "GL-52 De-Escalator",
    "Plas-45 Epoch",
    "MS-11 Solo Silo",
    "EAT-700 Expendable Napalm",
    "S-11 Speargun",
    "CQC-9 Defoliation Tool",
    "M-1000 Maxigun",
    "GL-28 Belt-Fed Grenade Launcher",
    "EAT-411 Leveller",
    "CQC-20 Breaching Hammer",
    "B/MD C4 Pack",
    "B/FLAM-80 Cremator",
  ],
  "MechStratagems": [
    "EXO-45 Patriot Exosuit",
    "EXO-49 Emancipator Exosuit"
  ],
  "OneHandedWeapons": [
    "MP-98 Knight",
    "SMG-37 Defender",
    "SMG-72 Pummeler",
    "StA-11 SMG",
    "CB-9 Exploding Crossbow",
    "CQC-1 One True Flag",
    "M7S SMG",
    "SMG/FLAM-34 Stoker",
  ],
  "MeleeWeapons": [
    "R-2124 Constitution",
    "R-2 Amendment",
    "CQC-19 Stun Lance",
    "CQC-30 Stun Baton",
    "CQC-5 Combat Hatchet",
    "CQC-2 Saber",
    "K-2 Throwing Knife",
    "CQC-1 One True Flag",
    "CQC-42 Machete",
    "CQC-9 Defoliation Tool",
    "CQC-20 Breaching Hammer",
    "CQC-73 Entrenchment Tool",
  ],
  "SmokeWeapons": [
    "G-3 Smoke",
    "Eagle Smoke Strike",
    "Orbital Smoke Strike",
    "G-89 Smokescreen",
  ],
  "SpawnerWeapons": {
    "Terminid": {
      "primary": [
        "CB-9 Exploding Crossbow",
        "R-36 Eruptor"
      ],
      "secondary": [
        "GP-31 Grenade Pistol"
      ],
      "grenade": [
        "G-6 Frag",
        "G-10 Incendiary",
        "G-12 High Explosive",
        "G-13 Incendiary Impact",
        "G-16 Impact",
        "G-123 Thermite",
        "TED-63 Dynamite",
        "G-142 Pyrotech",
        "G-7 Pineapple",
        "G-48 Giga Grenade",
      ],
      "stratagem": [
        "AC-8 Autocannon",
        "EXO-45 Patriot Exosuit",
        "EXO-49 Emancipator Exosuit",
        "GL-21 Grenade Launcher",
        "GR-8 Recoilless Rifle",
        "LAS-99 Quasar Cannon",
        "MLS-4X Commando",
        "RL-77 Airburst Rocket Launcher",
        "StA-X3 W.A.S.P. Launcher",
        "S-11 Speargun",
        "B/MD C4 Pack",
        "GL-28 Belt-Fed Grenade Launcher",
        "TD-220 Bastion MK XVI",
      ]
    },
    "Automaton": {
      "primary": [
        "CB-9 Exploding Crossbow",
        "R-36 Eruptor"
      ],
      "secondary": [
        "GP-31 Grenade Pistol"
      ],
      "grenade": [
        "G-6 Frag",
        "G-10 Incendiary",
        "G-12 High Explosive",
        "G-13 Incendiary Impact",
        "G-16 Impact",
        "G-123 Thermite",
        "TED-63 Dynamite",
        "G-142 Pyrotech",
        "G-7 Pineapple",
        "G-48 Giga Grenade",
      ],
      "stratagem": [
        "AC-8 Autocannon",
        "Eagle 110m Rocket Pods",
        "Eagle Napalm Airstrike",
        "Eagle 500kg Bomb",
        "Eagle Airstrike",
        "Eagle Strafing Run",
        "EAT-17 Expendable Anti-Tank",
        "EXO-45 Patriot Exosuit",
        "EXO-49 Emancipator Exosuit",
        "FAF-14 Spear",
        "GL-21 Grenade Launcher",
        "GR-8 Recoilless Rifle",
        "LAS-99 Quasar Cannon",
        "MLS-4X Commando",
        "Orbital 120MM HE Barrage",
        "Orbital 380MM HE Barrage",
        "Orbital Napalm Barrage",
        "Orbital Walking Barrage",
        "RL-77 Airburst Rocket Launcher",
        "StA-X3 W.A.S.P. Launcher",
        "EAT-700 Expendable Napalm",
        "S-11 Speargun",
        "B/MD C4 Pack",
        "GL-28 Belt-Fed Grenade Launcher",
        "EAT-411 Leveller",
        "TD-220 Bastion MK XVI",
      ]
    },
    "Illuminate": {
      "primary": [
        "CB-9 Exploding Crossbow",
        "R-36 Eruptor"
      ],
      "secondary": [
        "GP-31 Grenade Pistol"
      ],
      "grenade": [
        "G-6 Frag",
        "G-10 Incendiary",
        "G-12 High Explosive",
        "G-13 Incendiary Impact",
        "G-16 Impact",
        "G-123 Thermite",
        "TED-63 Dynamite",
        "G-142 Pyrotech",
        "G-7 Pineapple",
        "G-48 Giga Grenade",
      ],
      "stratagem": [
        "AC-8 Autocannon",
        "Eagle 500kg Bomb",
        "Eagle Airstrike",
        "Eagle Strafing Run",
        "EAT-17 Expendable Anti-Tank",
        "EXO-45 Patriot Exosuit",
        "EXO-49 Emancipator Exosuit",
        "GL-21 Grenade Launcher",
        "GR-8 Recoilless Rifle",
        "LAS-99 Quasar Cannon",
        "MLS-4X Commando",
        "Orbital 120MM HE Barrage",
        "Orbital 380MM HE Barrage",
        "Orbital Walking Barrage",
        "RL-77 Airburst Rocket Launcher",
        "EAT-700 Expendable Napalm",
        "S-11 Speargun",
        "B/MD C4 Pack",
        "GL-28 Belt-Fed Grenade Launcher",
        "EAT-411 Leveller",
        "TD-220 Bastion MK XVI",
      ]
    }
  }
};

export default conf;
